<template>
  <dialog-reset title="检车报告" top="5vh" width="80%" height="80vh" custom-class="train-report-dialog" :visible="visible"
    :before-close="beforeClose" @updateHeight="updateTableHeight">
    <div class="panel-heading">
      <h3 class="panel-retitle">检车报告</h3>
    </div>
    <el-container v-loading="loading" style="background-color: white">
      <el-main>
        <div class="report-top-content">
          <el-form style="margin-bottom: 10px; font-size: 20px">
            <span>
              <span>过车时间：<span>{{ trainInfo.comeTime }}</span></span>
              <span style="margin-left: 10px">车厢节数：<span>{{ trainInfo.totalCars }}节</span></span>
            </span>
          </el-form>
          <div v-if="checkFlag == 1" style="margin-bottom: 10px; font-size: 16px">
            <span>检查时间：<span>{{ checkTime }}</span></span>
            <span style="margin-left: 10px">检查人：<span>{{ checkUser }}</span></span>
          </div>
          <div class="table-operate">
            <div class="item">
              显示全部：
              <el-switch class="show-all-switch" v-model="operateForm.showAll" active-value="1" inactive-value="0"
                active-text="ON" inactive-text="OFF" active-color="#5CB85C" inactive-color="#5BC0DE"></el-switch>
              <!-- :disabled="operateForm.showAll == showAll" -->

            </div>
            <div class="item">
              <div class="label">节数：</div>
              <el-input-number v-model="operateForm.trainSerial" controls-position="right" :min="0"
                :max="trainInfo.totalCars" @change="handleInput('trainSerial')"></el-input-number>
            </div>
            <div class="item">
              <div class="label">车号：</div>
              <el-input v-model="operateForm.trainNo" @input="handleInput('trainNo')"></el-input>
            </div>
            <div class="item">
              <div class="label">集装箱号：</div>
              <el-input v-model="operateForm.containerNo" @input="handleInput('containerNo')"></el-input>
            </div>
          </div>
        </div>
        <avue-crud v-if="visible" ref="reportCrud" class="report-dialog-crud" :option="option"
          :data="getData(data, operateForm.showAll, dict.type)">
          <!--修改标重字段-->
          <template #trainLoad="{ row }">
            <row-editor :fieldInfo="{ fieldLabel: '标重', fieldName: 'trainLoad' }" :row="row"
              :customParams="{ trainSerial: row.trainSerial }" @detailUpdate="handleUpdate"></row-editor>
          </template>
          <!--修改皮重(识别)字段-->
          <template #trainSelf="{ row }">
            <row-editor :fieldInfo="{ fieldLabel: '皮重(识别)', fieldName: 'trainSelf' }" :row="row"
              :fieldStyle="{ color: row.isTrainSelf ? 'red' : '' }" :customParams="{ trainSerial: row.trainSerial }"
              @detailUpdate="handleUpdate"></row-editor>
          </template>
          <!--修改容积字段-->
          <template #trainVolume="{ row }">
            <row-editor :fieldInfo="{ fieldLabel: '容积', fieldName: 'trainVolume' }" :row="row"
              :fieldStyle="{ color: row.isTrainVolume ? 'red' : '' }" :customParams="{ trainSerial: row.trainSerial }"
              @detailUpdate="handleUpdate"></row-editor>
          </template>
          <!--修改换长字段-->
          <template #trainChange="{ row }">
            <row-editor :fieldInfo="{ fieldLabel: '换长', fieldName: 'trainChange' }" :row="row"
              :fieldStyle="{ color: row.isTrainChange ? 'red' : '' }" :customParams="{ trainSerial: row.trainSerial }"
              @detailUpdate="handleUpdate"></row-editor>
          </template>
          <!--修改集装箱1-->
          <template #containerNo1="{ row }">
            <row-editor :fieldInfo="{
              fieldLabel: '集装箱号(1)',
              fieldName: 'containerNo1',
            }" :row="row" :customParams="{ trainSerial: row.trainSerial }" @detailUpdate="handleUpdate"></row-editor>
          </template>
          <!--修改集装箱2-->
          <template #containerNo2="{ row }">
            <row-editor :fieldInfo="{
              fieldLabel: '集装箱号(2)',
              fieldName: 'containerNo2',
            }" :row="row" :customParams="{ trainSerial: row.trainSerial }" @detailUpdate="handleUpdate"></row-editor>
          </template>
          <!--修改办单箱号1-->
          <template #bdContainerNoOne="{ row }">
            <row-editor :fieldInfo="{
              fieldLabel: '办单箱号(1)',
              fieldName: 'bdContainerNoOne',
            }" :row="row"
              :customParams="{ arriveId: row.arriveId, orderNo: row.orderNo, toLocation: row.toLocation, bdContainerNoTwo: row.bdContainerNoTwo }"
              @detailUpdate="handleUpdate" editUrl="/check/train/detailList/updateVehicleInspectionBdContainer"
              :fieldStyle="{ color: customFieldColor(row, 'bdContainerNoOne') }"></row-editor>
          </template>
          <!--修改办单箱号2-->
          <template #bdContainerNoTwo="{ row }">
            <row-editor :fieldInfo="{
              fieldLabel: '办单箱号(2)',
              fieldName: 'bdContainerNoTwo',
            }" :row="row"
              :customParams="{ arriveId: row.arriveId, orderNo: row.orderNo, toLocation: row.toLocation, bdContainerNoOne: row.bdContainerNoOne }"
              @detailUpdate="handleUpdate" editUrl="/check/train/detailList/updateVehicleInspectionBdContainer"
              :fieldStyle="{ color: customFieldColor(row, 'bdContainerNoTwo') }"></row-editor>
          </template>
          <!--修改起始地-->
          <template #toLocation="{ row }">
            <row-editor :fieldInfo="{
              fieldLabel: '办单到站',
              fieldName: 'toLocation',
            }" inputType="select" :options="bdOriginOption" :row="row"
              :customParams="{ arriveId: row.arriveId, orderNo: row.orderNo }" @detailUpdate="handleUpdate"
              editUrl="/check/train/detailList/updateOrderToLocation"
              :fieldStyle="{ color: customFieldColor(row, 'toLocation') }"></row-editor>
          </template>
          <template #threeClass="{ row }">
            <div v-for="(item, index) in row.threeClass.split(',')" :key="item + index" class="table-cell-list-item"
              :style="{ whiteSpace: 'normal', color: getThreeClassColor(row, index, 'threeClass') }">
              {{ item }}
            </div>
          </template>
          <template #camera="{ row }">
            <div v-for="(item, index) in row.camera.split(',')" :key="item + index" class="table-cell-list-item"
              style="white-space: normal"
              :style="{ whiteSpace: 'normal', color: getThreeClassColor(row, index, 'camera') }">
              {{ item.replaceAll("南侧", '右侧').replaceAll("北侧", '左侧') }}
            </div>
          </template>
          <template #addUser="{ row }">
            <div v-for="(item, index) in row.addUser.split(',')" :key="item + index" class="table-cell-list-item"
              style="white-space: normal"
              :style="{ whiteSpace: 'normal', color: getThreeClassColor(row, index, 'addUser') }">
              {{ item === '1' ? '人工标记' : item }}
            </div>
          </template>
          <!--修改处理类型(包含异常内容才允许处理)-->
          <template #proType="{ row }">
            <row-editor v-if="row.threeClass != '无'" inputType="select"
              :fieldInfo="{ fieldLabel: '处理类型', fieldName: 'proType' }" :row="row"
              :customParams="{ trainSerial: row.trainSerial }" :options="[
                { value: '0', label: '在列整理' },
                { value: '1', label: '甩车整理' },
                { value: '2', label: '重点关注' },
              ]"></row-editor>
            <div v-else>
              无
            </div>
          </template>
          <!--修改处理意见-->
          <template #remark="{ row }">
            <row-editor v-if="row.threeClass != '无'" :fieldInfo="{
              fieldLabel: '处理意见',
              fieldName: 'remark',
            }" :row="row" :customParams="{ trainSerial: row.trainSerial }" @detailUpdate="handleUpdate"></row-editor>
            <div v-else>
              无
            </div>
          </template>
          <!-- 属性图片 -->
          <template #proImages="{ row }">
            <div>
              <template v-if="!row.proImages || row.proImages === '无'">暂无图片</template>
              <template v-else>
                <div style="display: flex;align-items: center;justify-content: center;">
                  <el-button v-for="(img, idx) in row.proImages.split(',')" :key="idx" type="text"
                    @click="handleShowProImage(img, idx)" style="margin-right: 5px;">图片{{ idx + 1 }}</el-button>
                </div>
              </template>
            </div>
          </template>
          <!-- 查看图片 -->
          <template #pic="{ row }">
            <div>
              <template v-if="!row.pic || row.pic === '无'">暂无图片</template>
              <template v-else-if="row.pic">
                <div style="display: flex;align-items: center;justify-content: center;">
                  <el-button v-for="(img, idx) in row.pic.split(',')" :key="idx" type="text"
                    @click="handleShowProImage(img, idx)" style="margin-right: 5px;">图片{{ idx + 1 }}</el-button>
                </div>
                <!-- <div style="margin-bottom: 5px">
                  <div style="margin-top: 5px; height: 30px" v-for="(url, index) in row.picList" :key="index">
                    <el-image style="width: 70px; height: 30px" :src="url" :preview-src-list="[url]">
                      <div slot="error" class="image-slot">
                      </div>
                    </el-image>
                  </div>
                </div> -->
              </template>
            </div>
          </template>
          <template #menuLeft>
            <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出
            </el-button>

            <div style="display: inline-block;">
              <div style="display:flex;align-items: center;">
                <p style="font-size: 14px;margin-right: 10px;width: 100px;">办单到站:</p>
                <el-select v-model="value" placeholder="请选择" @change="bdOriginOptionChange">
                  <el-option v-for="item in bdOriginOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- <el-button
              v-if="direction === 'right'"
              type="primary"
              icon="el-icon-s-home"
              @click="bhjzxrk"
            >备货集装箱入库
            </el-button> -->
            <!-- <span class="menu-left-tip">建议在车辆到达、集装箱作业前完成入库，对于已经作业的集装箱列车，不要再执行入库</span> -->
          </template>
          <template #menu="{ row, index }">
            <el-button size="small" type="text" @click="getInfo(row, index)">查看图片
            </el-button>
          </template>
        </avue-crud>
      </el-main>
    </el-container>
    <span class="avue-dialog__footer">
      <el-button icon="el-icon-circle-check" type="primary" :loading="loading" @click="confirmReport">确 定</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('update:visible', false)">关 闭</el-button>
    </span>
    <div v-show="tagImgUrl" class="tag-img-box">
      <i class="el-icon-circle-close" @click="tagImgUrl = ''"></i>
      <img :src="tagImgUrl" />
    </div>
    <!-- <inout-picture :visible.sync="showPicture" :info="selectedRow" :add-index="addIndex"
      @detailUpdate="handleDetailUpdate" /> -->

  </dialog-reset>
</template>

<script>
// import InoutPicture from "@/views/handover-inspection/container-in-out/components/InoutPicture.vue";
import RowEdit from "@/components/matrix/row-edit";
import RowEditor from "@/components/matrix/row-editor";
import {
  getReport,
  confirmReport,
  exportExcel,
  updateOrderToLocation
} from "@/api/line/trainLineReport";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { downloadXls, getSysConfig, hijackFn } from "@/util/util";
import { getDicts } from "@/api/system/dict/data";
import { getRequest } from "@/api/matrixApi";

export default {
  name: "train-line-report",
  components: {
    RowEdit,
    RowEditor,
    // InoutPicture,
  },
  props: {
    visible: Boolean,
    // 车次信息
    trainInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    addIndex: [Number, String],
    direction: String,
    isHGZ: Boolean,
  },
  dicts: ['trainself_threshold', 'trainvolume_threshold', 'trainchange_threshold'],
  data() {
    return {
      updateUrl: "/check/train/detailList/update",
      dealTypeId: "",
      remarkId: "",
      editVal: "",
      tagImgUrl: "",
      operateForm: {
        showAll: "1", // 是否显示全部，"1" - 显示全部 "0" - 不显示全部
        trainSerial: undefined,
        trainNo: "",
        containerNo: "",
      },
      loading: false,
      editLoading: false,
      //修改字段请求参数
      ReportEditDTO: {
        id: "",
        fieldName: "",
        fieldVal: "",
        type: "",
      },
      checkTime: "", //检车时间
      containerNum: 0, // 集装箱数
      selectionList: [],
      dictionary: [],
      option: {
        index: false, // 索引是否显示
        selection: false, // 是否开启选择
        addBtn: false,
        viewBtn: false, // 查看按钮
        refreshBtn: false,
        editBtn: false,
        delBtn: false,
        menuWidth: 100,
        column: [
          {
            label: "车厢序号",
            prop: "trainSerial",
            width: 100,
            type: "input",
          },
          {
            label: "车型",
            prop: "trainType",
            width: 95,
            type: "input",
            html: true,
            formatter: function (row) {
              let str = "";
              if (!row.trainType || row.trainType === 'null') return ''
              if (row.trainTypeFlag === 0) {
                str += `<span style="color: red">${row.trainType}</span>`;
              } else {
                str += row.trainType;
              }
              return str;
            },
          },
          {
            label: "车号",
            prop: "trainNo",
            width: 115,
            type: "input",
            html: true,
            formatter: function (row) {
              if (!row.trainNo || row.trainNo === 'null') return ''
              return row.trainNo.length === 7 ? row.trainNo : `<span style="color: red">${row.trainNo}</span>`;
            },
          },
          {
            label: "标重(T)",
            prop: "trainLoad",
            width: 90,
          },
          {
            label: "毛重(T)",
            prop: "grossWeight",
            width: 90,
          },
          // {
          //   label: "皮重(T)",
          //   prop: "tareWeight",
          //   width: 90,
          // },
          // {
          //   label: "净重(T)",
          //   prop: "netWeight",
          //   width: 90,
          // },
          {
            label: "皮重(识别)(T)",
            prop: "trainSelf",
            // trainself_threshold
            width: 150,
          },
          {
            label: "容积(m³)",
            prop: "trainVolume",
            // trainvolume_threshold
            width: 99,
          },
          {
            label: "换长",
            prop: "trainChange",
            // trainchange_threshold
            width: 70,
          },
          {
            label: "属性缩略图",
            prop: "proImages",
            width: 180,
          },
          {
            label: "集装箱号(1)",
            prop: "containerNo1",
            minWidth: 130,
          },
          {
            label: "集装箱号(2)",
            prop: "containerNo2",
            minWidth: 130,
          },
          {
            label: "办单箱号(1)",
            prop: "bdContainerNoOne",
            minWidth: 130,
          },
          {
            label: "办单箱号(2)",
            prop: "bdContainerNoTwo",
            minWidth: 130,
          },
          {
            label: "办单到站",
            prop: "toLocation",
            minWidth: 150,
            ...this.railwayStation(0),
            dicFormatter: this.setBdOriginOption
          },
          {
            label: "办单列次名称",
            prop: "trainName",
            width: 180,
            overHidden: true,
          },
          {
            label: "异常内容",
            prop: "threeClass",
            minWidth: 130,
            overHidden: true,
          },
          {
            label: "面位",
            prop: "camera",
          },
          {
            label: "查看图片",
            prop: "pic",
            width: 100,
          },
          {
            label: "提报来源",
            prop: "addUser",
            width: 100,
          },
          {
            label: "处理类型",
            prop: "proType",
            width: 100,
          },
          {
            label: "处理意见",
            prop: "remark",
            minWidth: 130,
          },
        ],
      },
      checkFlag: undefined,
      checkUser: "",
      data: [],
      dealOptions: [],
      showPicture: false,
      selectedRow: {},
      bdOriginOption: [],

      value: '',
    };
  },
  computed: {
    getData() {
      // showAll: "1", // 是否显示全部，"1" - 显示全部 "0" - 不显示全部
      return function (data, showAll, dicts) {
        let trainself_threshold = {}
        for (let i = 0; i < dicts.trainself_threshold.length; i++) {
          trainself_threshold[dicts.trainself_threshold[i].label] = Number(dicts.trainself_threshold[i].value)
        }
        let trainvolume_threshold = {}
        for (let i = 0; i < dicts.trainvolume_threshold.length; i++) {
          trainvolume_threshold[dicts.trainvolume_threshold[i].label] = Number(dicts.trainvolume_threshold[i].value)
        }
        let trainchange_threshold = {}
        for (let i = 0; i < dicts.trainchange_threshold.length; i++) {
          trainchange_threshold[dicts.trainchange_threshold[i].label] = Number(dicts.trainchange_threshold[i].value)
        }
        // console.log('皮重', trainself_threshold)
        // console.log('容积', trainvolume_threshold)
        // console.log('换长', trainchange_threshold)

        let list = data.filter(res => {
          if (showAll == 1) {
            return true
          } else {
            if (res.threeClass != '无') {
              return true
            } else if (!isInRange(res.trainSelf, trainself_threshold.min, trainself_threshold.max)) {
              return true
            } else if (!isInRange(res.trainVolume, trainvolume_threshold.min, trainvolume_threshold.max)) {
              return true
            } else if (!isInRange(res.trainChange, trainchange_threshold.min, trainchange_threshold.max)) {
              return true
            } else  if (this.isNull(res.bdContainerNoOne) && this.isNull(res.bdContainerNoTwo) && this.isNull(res.containerNo1)&& this.isNull(res.containerNo2)) {
              return false
            } else if (this.isNull(res.bdContainerNoOne) && this.isNull(res.bdContainerNoTwo)) {
              return false
            } else if ( this.isNull(res.containerNo1)&& this.isNull(res.containerNo2)) {
              return false
            } else  if (!(res.bdContainerNoOne == res.containerNo1 || res.bdContainerNoOne == res.containerNo2)) {
              return true
            } else if (!(res.bdContainerNoTwo == res.containerNo1 || res.bdContainerNoTwo == res.containerNo2)) {
              return true
            } else {
              return false
            }
          }
        })


        function isInRange(value, min, max) {
          return value >= min && value <= max;
        }

        // console.log('list', list)
        return list.map((item) => {
          return {
            ...item,
            isTrainSelf: !isInRange(item.trainSelf, trainself_threshold.min, trainself_threshold.max),
            isTrainVolume: !isInRange(item.trainVolume, trainvolume_threshold.min, trainvolume_threshold.max),
            isTrainChange: !isInRange(item.trainChange, trainchange_threshold.min, trainchange_threshold.max),
          }
        })
      }
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.getList();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    getDicts("deal_type").then((res) => {
      this.dealOptions = res.data || [];
    });
  },
  methods: {
    // 获取列表数据
    getList() {
      this.loading = true;
      const params = {
        trainListId: this.trainInfo.id,
        showAll: this.operateForm.showAll,
      };
      getReport(params).then((res) => {
        const {
          code,
          data: { checkFlag, checkUser, checkTime, containerNum = 0, detailList = [] },
        } = res;
        if (code === 200) {
          this.checkFlag = checkFlag;
          this.checkUser = checkUser;
          this.checkTime = checkTime;
          this.containerNum = containerNum
          this.data = detailList
          // .map(item => ({
          //   ...item,
          //   // 不再处理picList、proImagesList
          // }));
          this.value = detailList[0].toLocation
        }
      })
        .finally(() => {
          this.loading = false;
        });
    },
    onEdit(item, fieldName) {
      this.dealTypeId = "";
      this.remarkId = "";
      this[fieldName + "Id"] = item.id;
      this.editVal = item[fieldName].toString();
    },
    // 根据车节/车号/集装箱号快速定位
    handleInput(prop) {
      const tableWrapper = document.querySelector(
        ".report-dialog-crud .el-table__body-wrapper"
      );
      const tableRowList = document.querySelectorAll(
        ".report-dialog-crud .el-table__body-wrapper .el-table__row"
      );
      let height = 0;
      const dataLength = this.data.length;
      for (let i = 0; i < dataLength; i++) {
        const item = this.data[i];
        const val = this.operateForm[prop];
        const compareVal = item[prop];
        let isExist = false;
        if (prop === "trainSerial") {
          isExist = val === compareVal;
        } else if (val) {
          if (prop === "containerNo") {
            const containerNo1 = item.containerNo1 || "";
            const containerNo2 = item.containerNo2 || "";
            isExist =
              containerNo1.indexOf(this.operateForm[prop]) !== -1 ||
              containerNo2.indexOf(this.operateForm[prop]) !== -1;
          } else {
            isExist = compareVal && compareVal.indexOf(val) !== -1;
          }
        }
        if (isExist) {
          tableWrapper && tableWrapper.scrollTo(0, height);
          break;
        }
        const rowHeight = tableRowList[i].offsetHeight;
        height += rowHeight;
      }
    },

    //定检期异常：定检期<过车时间（整行标为橙色）
    tableRowClassName({ row }) {
      let createTime = row.createTime.substring(2, 7).split("-");
      let createTimeStr = "";
      createTimeStr = createTime[0] + createTime[1];

      let inspectTimeArr = row.inspectTime ? row.inspectTime.split("-") : "";
      let inspectTimeStr = inspectTimeArr[0] + inspectTimeArr[1];

      if (!row.inspectTime || row.inspectTime.indexOf("*") === -1) {
        if (inspectTimeStr < createTimeStr) {
          return "warning-row";
        }
      }
      return "";
    },

    // 检车报告导出数据
    exportExcel() {
      this.$confirm("确认导出“检车报告”?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          trainListId: this.trainInfo.id,
          showAll: this.operateForm.showAll,
        };
        NProgress.start();
        exportExcel(params).then((res) => {
          res && downloadXls(res, `检车报告.xlsx`);
          NProgress.done();
        });
      });
    },
    bhjzxrk() {
      this.$confirm(`将有${this.containerNum}个集装箱入库，请确认箱号正确!`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        getRequest('/check/train/detailList/pushContainer', { trainListId: this.trainInfo.id }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg)
          }
        }).finally(() => {
          this.loading = false
        })
      })

    },
    beforeClose(done) {
      if (this.visible) this.$emit("update:visible", false);
      if (done) done();
    },

    //检车报告确认
    confirmReport() {
      if (this.checkFlag == 1) {
        this.$message.warning("已完成检车，请点击关闭按钮");
        return;
      }
      this.$confirm("是否确定检车完成?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        confirmReport(this.trainInfo.id).then(() => {
          this.$emit("reportConfirm", false);
          this.$message({
            type: "success",
            message: "保存成功!",
          });
        });
      });
    },

    validateInspectTime(inspectTime) {
      if (
        inspectTime !== "" &&
        inspectTime !== null &&
        inspectTime !== "undefined"
      ) {
        if (inspectTime.length != 5) {
          this.$message.error("字符长度为5 格式:22-06!");
          return false;
        }
        let arr = inspectTime.split("-");
        if (arr.length != 2) {
          this.$message.error("格式错误，没有包含“-“ 格式:22-06!");
          return false;
        }
        if (arr.length === 2 && Number(arr[1]) > 12) {
          this.$message.error("格式错误，月份输入有误!");
          return false;
        }
        let regex = /^[0-9]*$/;
        if (!regex.exec(arr[0]) || !regex.exec(arr[1])) {
          this.$message.error("请输入数字 格式:22-06!");
          return false;
        }
        return true;
      }
      return true;
    },
    // 查看图片
    getInfo(row, index) {
      this.selectedRow = {
        ...row,
        trainListId: this.trainInfo.id,
        poundno: this.trainInfo.poundno,
        index,
      };

      this.showPicture = true;
    },
    handleDetailUpdate(info) {
      this.data.splice(info.index, 1, info);
      this.$emit("updateCarriage", this.data[info.index]);
    },
    handleUpdate(info, field) {
      if (field === "toLocation") {
        this.getList()
      }
      this.$emit("updateCarriage", info);
    },

    // 给需要修改的单元格单独设置样式
    /*cellStyle({columnIndex}) {
      if (columnIndex === 3 || columnIndex === 4 || columnIndex ===5 || columnIndex ===6 || columnIndex ===8) {
        return {
          color: "#409eff",
          cursor: "pointer",
        };
      }
    },*/
    /**
     *
     * @param row 行数据
     * @param index 车厢异常列表下标
     * @param type 所属字段
     * @returns {string}
     */
    getThreeClassColor(row, index, type) {
      const confirm = row.confirm.split(',')[index]
      if (confirm === '未处理') {
        // 异常内容颜色处理
        if (type === 'threeClass') {
          const exceptionLevel = row.exceptionLevel.split(',')[index]
          if (exceptionLevel === '1') {
            return 'red'
          } else if (exceptionLevel === '2') {
            return 'orange'
          } else if (exceptionLevel === '3') {
            return '#F0F000'
          }
        } else {
          // 面位，提报来源 颜色处理
          return 'red'
        }
      }
      return ''
    },
    updateTableHeight(height, dialogBody, isFUll) {
      this.$nextTick(() => {
        const ThCrud = this.$refs.reportCrud.$refs;
        const titleH = dialogBody.querySelector('.panel-heading').offsetHeight
        const topH = dialogBody.querySelector('.report-top-content').offsetHeight
        const footerH = dialogBody.querySelector('.avue-dialog__footer').offsetHeight
        const headerMenu = ThCrud.headerMenu.$el.offsetHeight || 0
        this.$refs.reportCrud.tableHeight = height - titleH - topH - headerMenu - footerH - 35
      })
    },
    setBdOriginOption(res) {
      this.bdOriginOption = res.map(item => {
        return { label: item.stationName, value: item.stationCode };
      });
      return res
    },
    customFieldColor(row, field) {
      if (field === 'toLocation' && row[field]) {
        return (this.isHGZ && row[field] === '2') || (!this.isHGZ && row[field] === '1') ? '#1c7ab3' : 'red'
      }
      if (field === 'bdContainerNoOne' && row[field]) {
        return (row.bdContainerNoOne === row.containerNo1 || row.bdContainerNoOne === row.containerNo2) ? '#1c7ab3' : 'red'
      }
      if (field === 'bdContainerNoTwo' && row[field]) {
        return (row.bdContainerNoTwo === row.containerNo1 || row.bdContainerNoTwo === row.containerNo2) ? '#1c7ab3' : 'red'
      }
      return '#1c7ab3'
    },
    // 办单到站变化
    bdOriginOptionChange(val) {
      let orderNoList = [...new Set(this.data.map(item => item.orderNo))].filter(item => item)

      updateOrderToLocation({
        toLocation: val,
        orderNoList
      }).then(res => {
        if (res.code === 200) {
          this.getList()
          this.$message.success('办单到站修改成功')
        }
      })
    },
    async handleShowProImage(imgKey, idx) {
      // 假设proImages存的是图片位置标识，如L/M/R
      console.log(imgKey)
      if (!imgKey) return;
      this.loading = true;

      // 组装真实图片路径
      this.getImageUrl(imgKey, 'check').then(url => {
        const arr = [{ url: url, type: 'img' }]
        this.$ImagePreview(arr, 0, {
          interval: 3000,
          closeOnClickModal: true,
        });
        console.log(url)

      }).catch(() => {
        this.$message.error('图片加载失败');
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.train-line-report-dialog {
  .el-dialog__body {
    padding: 20px;
  }
}
</style>

<style lang="scss" scoped>
::v-deep .el-table--mini {
  font-size: 20px;

  .table-cell-list-item {
    border-bottom: 1px solid #b1b1b1;

    &:last-child {
      border-bottom: none;
    }
  }

  .el-button--small {
    font-size: 20px;
  }

  .el-table__cell {
    height: 55px;
  }
}

::v-deep .el-table .el-table__header-wrapper th {
  font-size: 20px;
}

::v-deep .el-table__fixed-header-wrapper .cell {
  font-size: 20px;
}

::v-deep .avue-crud .avue-crud__menu .avue-crud__left {
  font-size: 16px;
}

::v-deep .train-line-report-dialog {
  max-height: 100%;
  max-width: 100%;
}

.el-header {
  padding: 0 0;
  height: 40px;
}

.panel-heading {
  padding: 5px;
  color: #fff;
  background-color: #3ca2e0;
}

.panel-retitle {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 28px;
  color: inherit;
  text-align: center;
}

.tag-for-box {
  border-bottom: 1px solid #eeeeee;

  i {
    cursor: pointer;
  }

  .tag-for-cc {
    color: #409eff;
    cursor: pointer;
  }
}

.tag-img-box {
  position: absolute;
  width: 90%;
  background-color: #00aeff;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  i {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 30px;
    color: #ffffff;
    cursor: pointer;
    z-index: 2100;
  }

  img {
    width: 100%;
  }
}

::v-deep .warning-row {
  background-color: #ffa500 !important;
  color: #fff;
}

::v-deep .success-row {
  background-color: #67c23a !important;
  color: #fff;
}

::v-deep .warning-row.hover-row td,
.success-row.hover-row td {
  background-color: initial !important;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background-color: initial !important;
}

.table-operate {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #606266;
  margin-bottom: 10px;

  .item {
    display: flex;
    align-items: center;

    .label {
      flex: none;
      margin-left: 20px;
    }
  }
}

.el-main {
  padding: 10px 10px 25px;
}

::v-deep .el-dialog__body {
  min-height: 25vh;
  max-height: 90vh;
  overflow: auto;
}

::v-deep .train-report-dialog {
  zoom: 1.06;
}

.menu-left-tip {
  color: #ff0000;
  font-size: 18px;
}
</style>
<style lang="scss">
/* switch按钮样式 */
.show-all-switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}

/*打开时文字位置设置*/
.show-all-switch .el-switch__label--right {
  z-index: 1;
}

/* 调整打开时文字的显示位子 */
.show-all-switch .el-switch__label--right span {
  margin-right: 9px;
}

/*关闭时文字位置设置*/
.show-all-switch .el-switch__label--left {
  z-index: 1;
}

/* 调整关闭时文字的显示位子 */
.show-all-switch .el-switch__label--left span {
  margin-left: 48px;
}

/*显示文字*/
.show-all-switch .el-switch__label.is-active {
  display: block;
}

/* 调整按钮的宽度 */
.show-all-switch.el-switch .el-switch__core,
.el-switch .el-switch__label {
  // width: 106px !important;
  height: 34px;
  margin: 0;
  border-radius: 0;
  line-height: 34px;
  padding: 0 15px;
}

.show-all-switch.el-switch .el-switch__core {
  &:after {
    width: 52px;
    height: 32px;
    border-radius: 0;
    top: 0;
    left: 0;
  }
}

.el-switch.is-checked .el-switch__core::after {
  right: 0;
  left: auto !important;
}
</style>
